// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"01b0f8f3","81":"653ccaee","177":"e4a01e6b","199":"55f09df0","488":"23c5adc8","867":"7299567d"}[chunkId] + ".chunk.js";
};